import React, { useState, useEffect } from "react";
import { postData, uploadFile, getData } from "../../../webService/webservice.js";
import { toast } from "react-toastify";
import TVFMLoader from "../Loader/loader.jsx";
import CategorySelect from "../../Challange/CategorySelect.jsx";
import AddCategoryForm from "../Category/AddCategoryForm.jsx";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import StockImagePicker from "../../../components/Common/ImagePicker/StockImagePicker.jsx";
import { Icon } from "@iconify/react";
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
const AddSubCategoryForm = ({ onSuccess, onCancel, initialStoreId, initialCategoryId, categoryName, hideAddCategory }) => {
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const [subcategoryImage, setsubCategoryImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [isAddCategory, setIsAddCategory] = useState(false);
    const [categoryRefreshKey, setCategoryRefreshKey] = useState(0);
    const [showLoader, setShowLoader] = useState(false);
    const [errors, setErrors] = useState({});
    const [stores, setStores] = useState([]);

    const [uploadMethod, setUploadMethod] = useState("Normal");
    const [showStockPicker, setShowStockPicker] = useState(false);
    const [selectedStockImage, setSelectedStockImage] = useState(null);

    const [formData, setFormData] = useState({
        storeId: initialStoreId || "",
        categoryId: initialCategoryId || "",
        categoryName: categoryName || "",
        subCategoryName: '',
        subCategoryImageObject: '',
    });

    useEffect(() => {
        if (initialStoreId) {
            const fetchStoreLabel = async () => {
                try {
                    const token = localStorage.getItem("Token");
                    const res = await getData(`stores/store/${initialStoreId}`, {}, token);
                    if (res?.data) {
                        setStores([{ value: res.data._id, label: res.data.storeName }]);
                    }
                } catch (err) {
                    console.error("Failed to fetch initial store label", err);
                }
            };
            fetchStoreLabel();
        }
    }, [initialStoreId]);

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const token = localStorage.getItem("Token");
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                token
            );
            const results = res?.data?.results || [];
            const options = results.map(store => ({ value: store._id, label: store.storeName }));
            return { options, hasMore: results.length === 10, additional: { page: page + 1 } };
        } catch (err) {
            return { options: [], hasMore: false };
        }
    };

    const loadCategories = async (inputValue, loadedOptions, { page }) => {
        try {
            const token = localStorage.getItem("Token");
            const params = { page, limit: 10, search: inputValue, storeId: formData.storeId };
            const res = await getData('categories/categories', params, token);
            const results = res?.data?.results?.[0]?.paginatedResults || [];
            const options = results.map(cat => ({ value: cat._id, label: cat.categoryName }));
            return { options, hasMore: results.length === 10, additional: { page: page + 1 } };
        } catch (err) {
            return { options: [], hasMore: false };
        }
    };

    const validateFields = (data, method, img, stockImg) => {
        let newErrors = {};
        if (!data.storeId) newErrors.storeId = "Store is required";
        if (!data.categoryId) newErrors.categoryId = "Category is required";
        if (method === "Normal" && img) {
            const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
            const allowedExtensions = ["jpg", "jpeg", "png"];
            const fileExtension = img.name.split('.').pop().toLowerCase();
            const isValidType = allowedTypes.includes(img.type) || allowedExtensions.includes(fileExtension);
            if (!isValidType) {
                newErrors.subCategoryImage = "Only JPEG, JPG, and PNG images are allowed.";
            } else if (img.size > 1024 * 1024) {
                newErrors.subCategoryImage = "Image size exceeds 1MB. Please select an image smaller than 1MB.";
            }
        }
        if (!data.subCategoryName?.trim()) newErrors.subCategoryName = "SubCategory Name is required";
        return newErrors;
    };

    const handleAddSubCategory = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData, uploadMethod, subcategoryImage, selectedStockImage);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let finalImageObject = null;

            // ✅ NORMAL UPLOAD
            if (uploadMethod === "Normal") {
                if (subcategoryImage && userId) {
                    const uploadResult = await uploadFile(`files/upload/${userId}`, subcategoryImage);

                    if (uploadResult?.status === 200 || uploadResult?.success) {
                        finalImageObject = uploadResult.data;
                    } else {
                        toast.error(uploadResult?.message || "Image upload failed");
                        setShowLoader(false);
                        return;
                    }
                }
            }

            // ✅ STOCK IMAGE
            else {
                finalImageObject = selectedStockImage;
            }



            const subCategoryData = {
                storeId: formData.storeId,
                categoryId: formData.categoryId,
                subCategoryName: formData.subCategoryName,
                subCategoryImageObject: finalImageObject,

                // ✅ NOW WORKS CORRECTLY
                imageSource: uploadMethod === "Stock" ? "Stock" : "Upload"
            };

            console.log("FINAL PAYLOAD 👉", JSON.stringify(subCategoryData, null, 2));

            const response = await postData("subcategories/", subCategoryData, token);

            toast.success(response.message || "Sub Category added successfully");

            onSuccess(response.data);

        } catch (error) {
            console.error("Add SubCategory Error:", error);
            toast.error(error.message || "Add SubCategory Failed");
        } finally {
            setShowLoader(false);
        }
    };

    const handleRemoveImage = () => {
        setPreviewUrl(null);
        setsubCategoryImage(null);
        setSelectedStockImage(null);
    };

    const handleStockSelect = (imageObject) => {
        if (!imageObject) return;
        setSelectedStockImage(imageObject);
        const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
        const uri = imageObject.uri || imageObject.fileObject?.uri || "";
        if (uri) {
            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
        }
        setShowStockPicker(false);
        setErrors(prev => ({ ...prev, subCategoryImage: null }));
    };

    return (
        <div className="add-category-popup-form">
            {showLoader && (
                <div className="scissor-overlay">
                    <div className="scissor-loader"><TVFMLoader /></div>
                </div>
            )}
            <h3>Add SubCategory</h3>
            <form className="category-form" onSubmit={handleAddSubCategory}>
                <div className="category-form-row">
                    <div className="category-form-group">
                        <label className="input-label">Branch Name</label>
                        <StoreMultiSelect
                            value={stores}
                            onChange={(val) => {
                                setStores(val);
                                setFormData(prev => ({ ...prev, storeId: val && val.length > 0 ? val[0].value : "", categoryId: "", categoryName: "" }));
                            }}
                            loadStores={loadStores}
                            loggedInRole={role}
                            assignedStoreIds={adminStoreIds}
                            isMulti={false}
                        />
                        {errors.storeId && <p className="field-error">{errors.storeId}</p>}
                    </div>
                    <div className="category-form-group">
                        <label className="input-label">Category Name</label>
                        <CategorySelect
                            key={`${formData.storeId}-${categoryRefreshKey}`}
                            value={formData.categoryId ? { value: formData.categoryId, label: formData.categoryName || "Selected Category" } : null}
                            onChange={(val) => {
                                setFormData(prev => ({ ...prev, categoryId: val?.value || "", categoryName: val?.label || "" }));
                            }}
                            loadCategories={loadCategories}
                            isMulti={false}
                            loggedInRole={role}
                            onAddCategory={hideAddCategory ? undefined : () => setIsAddCategory(true)}
                        />
                        {errors.categoryId && <p className="field-error">{errors.categoryId}</p>}
                    </div>
                    <div className="category-form-group">
                        <label className="input-label">SubCategory Name</label>
                        <input
                            type="text"
                            placeholder="Enter subcategory name"
                            className="category-input"
                            value={formData.subCategoryName}
                            onChange={e => setFormData(prev => ({ ...prev, subCategoryName: e.target.value }))}
                        />
                        {errors.subCategoryName && <p className="field-error">{errors.subCategoryName}</p>}
                    </div>

                    <div className="category-form-group" style={{ gridColumn: 'span 2' }}>
                        <label className="input-label">SubCategory Image (Max 1MB, JPEG/JPG/PNG only)</label>
                        <div className="upload-options" style={{ display: 'flex', gap: '20px', marginBottom: '12px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                <input
                                    type="radio"
                                    name="uploadMethod"
                                    checked={uploadMethod === "Normal"}
                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                    onChange={() => {
                                        setUploadMethod("Normal");
                                        setPreviewUrl(subcategoryImage ? URL.createObjectURL(subcategoryImage) : null);
                                    }}
                                />
                                Normal Upload
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                <input
                                    type="radio"
                                    name="uploadMethod"
                                    checked={uploadMethod === "Stock"}
                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                    onChange={() => {
                                        setUploadMethod("Stock");
                                        if (selectedStockImage) {
                                            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                            const uri = selectedStockImage.uri || selectedStockImage.fileObject?.uri || "";
                                            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
                                        } else {
                                            setPreviewUrl(null);
                                        }
                                    }}
                                />
                                Stock Image
                            </label>
                        </div>

                        {uploadMethod === "Normal" ? (
                            <input
                                type="file"
                                accept=".jpeg,.jpg,.png"
                                className="category-input"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                                        const allowedExtensions = ["jpg", "jpeg", "png"];
                                        const fileExtension = file.name.split('.').pop().toLowerCase();
                                        const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);

                                        if (!isValidType) {
                                            setErrors(prev => ({ ...prev, subCategoryImage: "Only JPEG, JPG, and PNG images are allowed." }));
                                            toast.error("Only JPEG, JPG, and PNG images are allowed.");
                                            setsubCategoryImage(null);
                                            setPreviewUrl(null);
                                            if (e.target) e.target.value = "";
                                        } else if (file.size > 1024 * 1024) {
                                            setErrors(prev => ({ ...prev, subCategoryImage: "Image size exceeds 1MB. Please select an image smaller than 1MB." }));
                                            toast.error("Image size exceeds 1MB. Please select an image smaller than 1MB.");
                                            setsubCategoryImage(null);
                                            setPreviewUrl(null);
                                            if (e.target) e.target.value = "";
                                        } else {
                                            setsubCategoryImage(file);
                                            setPreviewUrl(URL.createObjectURL(file));
                                            setErrors(prev => ({ ...prev, subCategoryImage: null }));
                                        }
                                    }
                                }}
                            />
                        ) : (
                            <div className="stock-picker-trigger">
                                <button
                                    type="button"
                                    className="select-stock-btn"
                                    onClick={() => setShowStockPicker(true)}
                                    style={{
                                        width: '100%',
                                        padding: '8px 12px',
                                        background: '#fff',
                                        border: '1px solid #ccc',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        textAlign: 'left',
                                        justifyContent: 'flex-start',
                                        gap: '10px',
                                        fontSize: '14px',
                                        color: selectedStockImage ? '#333' : '#888'
                                    }}
                                >
                                    <Icon icon="mdi:image-search" style={{ fontSize: '18px', color: '#64748b' }} />
                                    {selectedStockImage ? `Selected: ${selectedStockImage.name || 'Stock Image'}` : "Click to select a stock image..."}
                                </button>
                            </div>
                        )}
                        {errors.subCategoryImage && <p className="field-error">{errors.subCategoryImage}</p>}
                        {previewUrl && (
                            <div className="image-preview" style={{ marginTop: '12px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                <div style={{ position: 'relative' }}>
                                    <img src={previewUrl} alt="Preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '-8px',
                                            right: '-8px',
                                            background: '#ef4444',
                                            color: 'white',
                                            borderRadius: '50%',
                                            width: '20px',
                                            height: '20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                            zIndex: 5
                                        }}
                                        onClick={handleRemoveImage}
                                        title="Remove image"
                                    >
                                        <Icon icon="mdi:close" style={{ fontSize: '14px' }} />
                                    </div>
                                </div>
                                {uploadMethod === "Stock" && selectedStockImage && (
                                    <div style={{ paddingTop: '4px' }}>
                                        <p style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', margin: '0' }}>Stock Image Selected</p>
                                        <p style={{ fontSize: '11px', color: '#64748b', margin: '2px 0 0' }}>{selectedStockImage.name}</p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <div className="category-buttons">
                    <button className="add-Product-button" type="submit">Add SubCategory</button>
                    <button className="cancel-Product-button" type="button" onClick={onCancel}>Cancel</button>
                </div>
            </form>
            {showStockPicker && (
                <StockImagePicker
                    onSelect={handleStockSelect}
                    onCancel={() => setShowStockPicker(false)}
                />
            )}
            {isAddCategory && (
                <div className="popup-overlay">
                    <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                        <Icon icon={closeIcon} className="popup-close-icon-outside" onClick={() => setIsAddCategory(false)} />
                        <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                            <AddCategoryForm
                                onSuccess={(newCat) => {
                                    setIsAddCategory(false);
                                    if (newCat) {
                                        const newId = newCat._id || newCat.id;
                                        const newName = newCat.categoryName || newCat.Name || "New Category";
                                        setFormData(prev => ({
                                            ...prev,
                                            categoryId: newId,
                                            categoryName: newName
                                        }));
                                        setCategoryRefreshKey(prev => prev + 1);
                                    }
                                }}
                                onCancel={() => setIsAddCategory(false)}
                                initialStoreId={formData.storeId}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddSubCategoryForm;
